/**
 * Linhas de apoio da folha "Mais". Cada uma é um componente próprio, montado só com a folha
 * aberta, para não buscar horas de plantão nem estado do VIDaaS fora dela.
 */
import { useState } from 'react'
import { usePlantoesMonthSummary } from '@/features/plantoes/usePlantoesMonthSummary'
import { useNewsUnreadCount } from '@/features/feedNews/useNewsUnreadCount'
import { useVidaasAuthStatus } from '@/hooks/useVidaasAuthStatus'
import {
  formatNewsUnreadSubtitle,
  formatPlantoesHoursSubtitle,
  formatSignatureSubtitle,
  type MobileMenuSubtitle as SubtitleKind,
} from '@/widgets/navigation/mobileMenuItems'

const SubtitleText = ({ text }: { text: string | null }) =>
  text ? <span className="block truncate text-xs font-medium text-[var(--color-text-secondary)]">{text}</span> : null

const PlantoesHours = () => {
  const { analytics, loading } = usePlantoesMonthSummary()
  const [now] = useState(() => new Date())
  return <SubtitleText text={loading ? null : formatPlantoesHoursSubtitle(analytics.totalHours, now)} />
}

const NewsUnread = () => <SubtitleText text={formatNewsUnreadSubtitle(useNewsUnreadCount())} />

const SignatureStatus = () => {
  const { cached, isLoading } = useVidaasAuthStatus()
  return <SubtitleText text={isLoading && !cached ? null : formatSignatureSubtitle(cached)} />
}

export const MobileMenuSubtitle = ({ kind }: { kind: SubtitleKind }) => {
  if (kind === 'plantoes-hours') return <PlantoesHours />
  if (kind === 'news-unread') return <NewsUnread />
  return <SignatureStatus />
}
